
// ROUTES
require('modules/invitation-transfer-event/routes/invitation-transfer-event');

// CONTROLLERS
require('modules/invitation-transfer-event/controllers/invitation-transfer-event');
require('modules/invitation-transfer-event/controllers/list');
require('modules/invitation-transfer-event/controllers/assign');

// SERVICES
require('modules/invitation-transfer-event/services/invitation-transfer-event');
require('modules/invitation-transfer-event/services/list');
require('modules/invitation-transfer-event/services/create');
require('modules/invitation-transfer-event/services/edit');
require('modules/invitation-transfer-event/services/delete');


angular.module('unica_invitation_transfer_event', [

	// ROUTES
	'unica_invitation_transfer_event.invitation_transfer_event_routes',

	// CONTROLLERS
	'unica_invitation_transfer_event.invitation_transfer_event_controllers',

	// SERVICES
	'unica_invitation_transfer_event.invitation_transfer_event_services'

]);